<p-toast />
<p-confirmdialog />

<div class="flex flex-column p-1 m-1">
  <div>
    <h2>News &amp; Updates Administration</h2>
    <p>Create, edit, and delete news items shown on the LipidCompass landing page and at <code>/news</code>.</p>

    <div class="flex mb-3">
      <p-button
        label="Add News Item"
        icon="fas fa-plus"
        iconPos="left"
        (onClick)="openAddDialog()">
      </p-button>
    </div>

    <p-table
      [value]="items"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 20]"
      responsiveLayout="stack"
      sortField="date"
      [sortOrder]="-1"
      class="p-datatable-sm">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="category" style="width: 9rem">Category <p-sortIcon field="category" /></th>
          <th pSortableColumn="date" style="width: 8rem">Date <p-sortIcon field="date" /></th>
          <th pSortableColumn="title">Title <p-sortIcon field="title" /></th>
          <th>Summary</th>
          <th style="width: 8rem">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <span class="p-column-title">Category</span>
            <p-tag
              [value]="item.category"
              [severity]="newsService.getCategorySeverity(item.category)">
            </p-tag>
          </td>
          <td><span class="p-column-title">Date</span>{{ item.date | date:'mediumDate':'en-US' }}</td>
          <td><span class="p-column-title">Title</span>{{ item.title }}</td>
          <td class="summary-cell"><span class="p-column-title">Summary</span>{{ item.summary }}</td>
          <td>
            <p-button-group>
              <p-button
                icon="fas fa-pen"
                [text]="true"
                pTooltip="Edit"
                (onClick)="openEditDialog(item)">
              </p-button>
              <p-button
                icon="fas fa-trash"
                [text]="true"
                severity="danger"
                pTooltip="Delete"
                (onClick)="confirmDelete(item)">
              </p-button>
            </p-button-group>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>

<!-- Add / Edit Dialog -->
<p-dialog
  [(visible)]="dialogVisible"
  [header]="isEditMode ? 'Edit News Item' : 'Add News Item'"
  [modal]="true"
  [style]="{ width: '42rem' }"
  [draggable]="false"
  [resizable]="false">

  <div class="flex flex-column gap-3 pt-2">

    <div class="flex flex-column gap-1">
      <label for="news-category" class="font-semibold">Category <span class="text-red-500">*</span></label>
      <p-select
        id="news-category"
        [options]="categoryOptions"
        [(ngModel)]="form.category"
        optionLabel="label"
        optionValue="value"
        class="w-full">
      </p-select>
    </div>

    <div class="flex flex-column gap-1">
      <label for="news-title" class="font-semibold">Title <span class="text-red-500">*</span></label>
      <input
        id="news-title"
        pInputText
        type="text"
        [(ngModel)]="form.title"
        placeholder="News item title"
        class="w-full" />
    </div>

    <div class="flex flex-column gap-1">
      <label for="news-date" class="font-semibold">Date <span class="text-red-500">*</span></label>
      <input
        id="news-date"
        pInputText
        type="date"
        [(ngModel)]="form.dateString"
        class="w-full" />
    </div>

    <div class="flex flex-column gap-1">
      <label for="news-summary" class="font-semibold">Summary <span class="text-red-500">*</span></label>
      <textarea
        id="news-summary"
        pTextarea
        [(ngModel)]="form.summary"
        placeholder="Short description shown in the news list"
        rows="3"
        class="w-full">
      </textarea>
    </div>

    <div class="flex flex-column gap-1">
      <label for="news-link" class="font-semibold">External Link <span class="text-color-secondary font-normal">(optional)</span></label>
      <input
        id="news-link"
        pInputText
        type="url"
        [(ngModel)]="form.externalLink"
        placeholder="https://..."
        class="w-full" />
    </div>

    <div class="flex flex-column gap-1">
      <label for="news-link-title" class="font-semibold">External Link Label <span class="text-color-secondary font-normal">(optional)</span></label>
      <input
        id="news-link-title"
        pInputText
        type="text"
        [(ngModel)]="form.externalLinkTitle"
        placeholder="Link display text"
        class="w-full" />
    </div>

  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" [text]="true" (onClick)="dialogVisible = false" />
    <p-button label="Save" icon="fas fa-save" iconPos="left" (onClick)="save()" />
  </ng-template>

</p-dialog>
